import { IconSVG } from '../types';

export const ChevronUp = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 40 40"
      style={style}
    >
      <path
        fill="currentColor"
        d="M20.5 18 14 24.5q-.459.459-1.167.458-.708 0-1.167-.458-.458-.458-.458-1.167 0-.707.458-1.166l7.667-7.667q.5-.5 1.167-.5.666 0 1.166.5l7.667 7.667q.459.458.458 1.166 0 .709-.458 1.167-.457.459-1.167.458-.707 0-1.166-.458z"
      />
    </svg>
  );
};
